import { render, staticRenderFns } from "./PcCheckmarkIcon.vue?vue&type=template&id=27554432&scoped=true"
import script from "./PcCheckmarkIcon.vue?vue&type=script&lang=js"
export * from "./PcCheckmarkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27554432",
  null
  
)

export default component.exports